import { useMemo } from 'react';
import type { AssistantRole } from './roles';
import {
  canAccessElevatedApps,
  canAccessMediaLibrary,
  canAccessSiteAdmin,
  hasAssistantRole,
  isAssistantAdmin,
  isAssistantSysAdmin
} from './roles';
import { useAuthStore } from './useAuthStore';

export function useHasRole() {
  const roles = useAuthStore((s) => s.roles);

  return useMemo(
    () => ({
      roles,
      hasAssistantRole: (required: AssistantRole) => hasAssistantRole(roles, required),
      canAccessElevatedApps: () => canAccessElevatedApps(roles),
      canAccessMediaLibrary: () => canAccessMediaLibrary(roles),
      canAccessSiteAdmin: () => canAccessSiteAdmin(roles),
      isAssistantSysAdmin: () => isAssistantSysAdmin(roles),
      /** Exact AssistantAdmin claim — prefer canAccessElevatedApps / canAccessSiteAdmin. */
      isAssistantAdmin: () => isAssistantAdmin(roles)
    }),
    [roles]
  );
}
